<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol class="d-flex" md="1"> </CCol>
            </CRow>
            <!-- Title page  -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardHeader>
                                <CContainer fluid>
                                    <!-- Filter -->
                                    <CRow class="justify-content-between">
                                        <CCol md="1">
                                            <ButtonBack
                                                class="mr-3"
                                                title="Go back"
                                            />

                                        </CCol>
                                        <CCol md="2">
                                            <CContainer fluid>
                                                <CRow>
                                                    <CCol>
                                                        <ButtonAction
                                                            @click="
                                                                openModal({
                                                                    modalName:
                                                                        'sendLeadToCampaign',
                                                                    data: {
                                                                        lead: {id: lead['id']},
                                                                    },
                                                                })
                                                            "
                                                        >
                                                                {{ $t("Send") }}
                                                        </ButtonAction>
                                                    </CCol>
                                                    <CCol>
                                                        <ButtonEdit
                                                            @click="
                                                                openModal({
                                                                    modalName:
                                                                        'quickLeadUpdate',
                                                                    data: {
                                                                        lead: lead,
                                                                    },
                                                                })
                                                            "
                                                        />
                                                    </CCol>
                                                </CRow>                                            
                                            </CContainer>
                                            
                                            
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardHeader>
                            <CCardBody>
                                <CContainer :fluid="true">
                                    <CRow>
                                        <CCol>
                                            <CCard>
                                                <CCardHeader>
                                                    <CContainer :fluid="true">
                                                        <CRow>
                                                            <CCol sm="11">
                                                                <h4>
                                                                    {{
                                                                        $t(
                                                                            "Details"
                                                                        )
                                                                    }}
                                                                </h4>
                                                                <p class="mb-0">
                                                                    {{
                                                                        $t(
                                                                            "This section displays lead details, including personal information, lead source, and activity timestamps."
                                                                        )
                                                                    }}
                                                                </p>
                                                            </CCol>
                                                        </CRow>
                                                    </CContainer>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CContainer :fluid="true">
                                                        <CRow>
                                                            <CCol md="4">
                                                                <h4>
                                                                    Lead
                                                                    information
                                                                </h4>
                                                                <p>
                                                                    Id:
                                                                    {{ LeadId }}
                                                                </p>
                                                                <p>
                                                                    Email:
                                                                    {{
                                                                        lead.email
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Phone:
                                                                    {{
                                                                        lead.fullPhone
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    First Name:
                                                                    {{
                                                                        lead.firstName
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Last Name:
                                                                    {{
                                                                        lead.lastName
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Gender:
                                                                    {{
                                                                        lead.genre
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Birth Date:
                                                                    {{
                                                                        lead.birthDate
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Cp:
                                                                    {{
                                                                        lead.cp
                                                                    }}
                                                                </p>
                                                            </CCol>
                                                            <CCol md="4">
                                                                <h4>
                                                                    Lead origin
                                                                </h4>
                                                                <p>
                                                                    Origin:
                                                                    {{
                                                                        lead.origin
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Ip:
                                                                    {{
                                                                        lead.ip
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Url:
                                                                    <a
                                                                        :href="
                                                                            lead.url1party
                                                                        "
                                                                        target="_blank"
                                                                        >{{
                                                                            lead.url1party
                                                                        }}</a
                                                                    >
                                                                </p>
                                                            </CCol>
                                                            <CCol md="4">
                                                                <h4>
                                                                    Lead
                                                                    activity
                                                                </h4>
                                                                <p>
                                                                    Timestamp:
                                                                    {{
                                                                        lead.timestamp1party
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Created at:
                                                                    {{
                                                                        lead.createdAt
                                                                    }}
                                                                </p>
                                                                <p>
                                                                    Modified on:
                                                                    {{
                                                                        lead.modifiedOn
                                                                    }}
                                                                </p>
                                                            </CCol>
                                                        </CRow>
                                                    </CContainer>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol>
                                            <CCard>
                                                <CCardHeader>
                                                    <CContainer :fluid="true">
                                                        <CRow>
                                                            <CCol sm="11">
                                                                <h4>
                                                                    {{
                                                                        $t(
                                                                            "Answers"
                                                                        )
                                                                    }}
                                                                </h4>
                                                                <p class="mb-0">
                                                                    {{
                                                                        $t(
                                                                            "The table displays all responses to custom questions from a lead, detailing each answer provided."
                                                                        )
                                                                    }}
                                                                </p>
                                                            </CCol>
                                                            <CCol sm="1">
                                                                <TableSettings
                                                                    :allFields="
                                                                        tables
                                                                            .leadDetailsAnswersTable
                                                                            .allFields
                                                                    "
                                                                    :activeFields.sync="
                                                                        tables
                                                                            .leadDetailsAnswersTable
                                                                            .fields
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                    </CContainer>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CDataTable
                                                        :addTableClasses="[
                                                            'table--sm',
                                                        ]"
                                                        :items="
                                                            tables
                                                                .leadDetailsAnswersTable
                                                                .items
                                                        "
                                                        :fields="
                                                            traslateArrayObjects(
                                                                {
                                                                    array: tables
                                                                        .leadDetailsAnswersTable
                                                                        .fields,
                                                                    fields: [
                                                                        'label',
                                                                    ],
                                                                }
                                                            )
                                                        "
                                                        :columnFilterValue.sync="
                                                            tables
                                                                .leadDetailsAnswersTable
                                                                .columnFilterValue
                                                        "
                                                        :sorterValue.sync="
                                                            tables
                                                                .leadDetailsAnswersTable
                                                                .sorterValue
                                                        "
                                                        @update:column-filter-value="
                                                            updateData()
                                                        "
                                                        @update:sorter-value="
                                                            updateData()
                                                        "
                                                        @pagination-change="
                                                            itemPerPage
                                                        "
                                                        :items-per-page="
                                                            tables
                                                                .leadDetailsAnswersTable
                                                                .rows
                                                        "
                                                        v-bind="
                                                            tables.leadDetailsAnswersTable
                                                        "
                                                    >
                                                        <template
                                                            #name="{ item }"
                                                        >
                                                            <td class="py-2">
                                                                {{
                                                                    storeGlobalFieldsAdvanceIndexById[
                                                                        item
                                                                            .fieldId
                                                                    ].name
                                                                }}
                                                            </td>
                                                        </template>
                                                    </CDataTable>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol>
                                            <CCard>
                                                <CCardHeader>
                                                    <CContainer :fluid="true">
                                                        <CRow>
                                                            <CCol sm="11">
                                                                <h4>
                                                                    {{
                                                                        $t(
                                                                            "Deliveries"
                                                                        )
                                                                    }}
                                                                </h4>
                                                                <p class="mb-0">
                                                                    {{
                                                                        $t(
                                                                            "The record shows all submissions made by a lead to a delivery campaign, detailing dates and statuses of each interaction."
                                                                        )
                                                                    }}
                                                                </p>
                                                            </CCol>
                                                            <CCol sm="1">
                                                                <TableSettings
                                                                    :allFields="
                                                                        tables
                                                                            .leadDetailsDeliveriesTable
                                                                            .allFields
                                                                    "
                                                                    :activeFields.sync="
                                                                        tables
                                                                            .leadDetailsDeliveriesTable
                                                                            .fields
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                    </CContainer>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CDataTable
                                                        :addTableClasses="[
                                                            'table--sm',
                                                        ]"
                                                        :items="
                                                            tables
                                                                .leadDetailsDeliveriesTable
                                                                .items
                                                        "
                                                        :fields="
                                                            traslateArrayObjects(
                                                                {
                                                                    array: tables
                                                                        .leadDetailsDeliveriesTable
                                                                        .fields,
                                                                    fields: [
                                                                        'label',
                                                                    ],
                                                                }
                                                            )
                                                        "
                                                        :columnFilterValue.sync="
                                                            tables
                                                                .leadDetailsDeliveriesTable
                                                                .columnFilterValue
                                                        "
                                                        :sorterValue.sync="
                                                            tables
                                                                .leadDetailsDeliveriesTable
                                                                .sorterValue
                                                        "
                                                        @update:column-filter-value="
                                                            updateData()
                                                        "
                                                        @update:sorter-value="
                                                            updateData()
                                                        "
                                                        @pagination-change="
                                                            itemPerPage
                                                        "
                                                        :items-per-page="
                                                            tables
                                                                .leadDetailsDeliveriesTable
                                                                .rows
                                                        "
                                                        v-bind="
                                                            tables.leadDetailsDeliveriesTable
                                                        "
                                                    >
                                                        <template
                                                            #clientName="{
                                                                item,
                                                            }"
                                                        >
                                                            <td class="py-2">
                                                                {{
                                                                    item.client
                                                                        .name
                                                                }}
                                                            </td>
                                                        </template>
                                                    </CDataTable>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol>
                                            <CCard>
                                                <CCardHeader>
                                                    <CContainer :fluid="true">
                                                        <CRow>
                                                            <CCol sm="11">
                                                                <h4>
                                                                    {{
                                                                        $t(
                                                                            "Pendings"
                                                                        )
                                                                    }}
                                                                </h4>
                                                                <p class="mb-0">
                                                                    {{
                                                                        $t(
                                                                            "The table displays all pending records for submissions to a delivery campaign, including their status and reason."
                                                                        )
                                                                    }}
                                                                </p>
                                                            </CCol>
                                                            <CCol sm="1">
                                                                <TableSettings
                                                                    :allFields="
                                                                        tables
                                                                            .leadDetailsPendingsTable
                                                                            .allFields
                                                                    "
                                                                    :activeFields.sync="
                                                                        tables
                                                                            .leadDetailsPendingsTable
                                                                            .fields
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                    </CContainer>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CDataTable
                                                        :addTableClasses="[
                                                            'table--sm',
                                                        ]"
                                                        :items="
                                                            tables
                                                                .leadDetailsPendingsTable
                                                                .items
                                                        "
                                                        :fields="
                                                            traslateArrayObjects(
                                                                {
                                                                    array: tables
                                                                        .leadDetailsPendingsTable
                                                                        .fields,
                                                                    fields: [
                                                                        'label',
                                                                    ],
                                                                }
                                                            )
                                                        "
                                                        :columnFilterValue.sync="
                                                            tables
                                                                .leadDetailsPendingsTable
                                                                .columnFilterValue
                                                        "
                                                        :sorterValue.sync="
                                                            tables
                                                                .leadDetailsPendingsTable
                                                                .sorterValue
                                                        "
                                                        @update:column-filter-value="
                                                            updateData()
                                                        "
                                                        @update:sorter-value="
                                                            updateData()
                                                        "
                                                        @pagination-change="
                                                            itemPerPage
                                                        "
                                                        :items-per-page="
                                                            tables
                                                                .leadDetailsPendingsTable
                                                                .rows
                                                        "
                                                        v-bind="
                                                            tables.leadDetailsPendingsTable
                                                        "
                                                    >
                                                        <template
                                                            #clientName="{
                                                                item,
                                                            }"
                                                        >
                                                            <td class="py-2">
                                                                {{
                                                                    item.client
                                                                        .name
                                                                }}
                                                            </td>
                                                        </template>
                                                    </CDataTable>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <QuickLeadUpdateModal
            v-bind="modals.quickLeadUpdate"
            :provider="ProviderUuid"
            :show.sync="modals.quickLeadUpdate.show"
            v-on:submit="updateData"
        />
        <SendLeadsToDeliveryCampaignModal
            v-bind="modals.sendLeadToCampaign"
            :leads="[modals.sendLeadToCampaign.data.lead]"
            :show.sync="modals.sendLeadToCampaign.show"
        />
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ChartGauge from "£lement/ChartGauge";
import ButtonBack from "£lement/ButtonBack";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import ButtonEdit from "~/components/ButtonEdit";
import ButtonAction from "~/components/ButtonAction";
import FilterFields from "~/components/FilterFields";
import QuickLeadUpdateModal from "./Components/QuickLeadUpdateModal";
import SendLeadsToDeliveryCampaignModal from "./Components/SendLeadsToDeliveryCampaignModal";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import modalMixin from "~/mixins/modal.js";

/** Others */
import {
    cilWarning,
    cilPlus,
    cilDataTransferDown,
    cilSettings,
    cilEnvelopeClosed,
} from "@coreui/icons";

import LeadDetailsAnswersTable from "./config/tables/LeadDetailsAnswersTable";
import LeadDetailsDeliveriesTable from "./config/tables/LeadDetailsDeliveriesTable";
import LeadDetailsPendingsTable from "./config/tables/LeadDetailsPendingsTable";

import { formatDate } from "~/utils/date.js";
import { CCardBody, CCardHeader, CContainer, CDataTable } from "@coreui/vue";
import { mapGetters } from "vuex";
import { snakeToCamel } from "../../../utils";

export default {
    name: "InputCampaignLeadDetails",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, modalMixin],
    components: {
        FilterDate,
        ChartGauge,
        ButtonBack,
        ButtonExport,
        ButtonEdit,
        ButtonAction,
        TableSettings,
        FilterFields,
        QuickLeadUpdateModal,
        SendLeadsToDeliveryCampaignModal
    },
    icons: {
        cilWarning,
        cilPlus,
        cilDataTransferDown,
        cilSettings,
        cilEnvelopeClosed,
    },
    data() {
        return {
            tables: {
                leadDetailsAnswersTable: LeadDetailsAnswersTable,
                leadDetailsDeliveriesTable: LeadDetailsDeliveriesTable,
                leadDetailsPendingsTable: LeadDetailsPendingsTable,
            },
            lead: {
                id: null,
                firstName: null,
                lastName: null,
                email: null,
                fullPhone: null,
                origin: null,
                providerId: null,
                createdAt: null,
                modifiedOn: null,
                answers: [],
            },
            modals: {
                quickLeadUpdate: {
                    show: false,
                    color: "primary",
                    size: "lg",
                    title: "Quick update",
                    data: {},
                },
                sendLeadToCampaign: {
                    show: false,
                    color: "primary",
                    title: "Send leads",
                    data: {
                        lead: null,
                    },
                }
            },
        };
    },
    computed: {
        ProviderUuid: function () {
            return this.$route.params.uuid;
        },
        LeadId: function () {
            return this.$route.params.id;
        },
        ...mapGetters({
            storeGlobalFieldsAdvanceIndexById: "global/fieldsAdvanceIndexById",
        }),
    },
    methods: {
        async updateData() {
            this.updatePageLoading(true);
            let { data } = await this.fetcher({
                baseURL: process.env.VUE_APP_API_SASS,
                url: `/input-campaign/${this.ProviderUuid}/leads/${this.LeadId}/`,
            });

            const LeadAnswers = data["answers"];
            const LeadDeliveries = data["deliveries"];
            const LeadPendings = data["pendings"];
            delete data["answers"];
            delete data["deliveries"];
            delete data[""];

            let leadAdapted = data;

            for (let i = 0; i < LeadAnswers.length; i++) {
                const answer = LeadAnswers[i];
                leadAdapted = {
                    ...leadAdapted,
                    [snakeToCamel(answer.fieldCode)]: answer.value,
                };
            }

            this.lead = leadAdapted;
            this.lead.birthDate = formatDate(data.birthDate);
            this.lead.createdAt = formatDate(data.createdAt);
            this.lead.modifiedOn = formatDate(data.modifiedOn);
            this.tables.leadDetailsAnswersTable.items = LeadAnswers;
            this.tables.leadDetailsDeliveriesTable.items = LeadDeliveries;
            this.tables.leadDetailsPendingsTable.items = LeadPendings;

            this.tables.leadDetailsAnswersTable.loading = false;
            this.tables.leadDetailsDeliveriesTable.loading = false;
            this.tables.leadDetailsPendingsTable.loading = false;

            this.updatePageLoading(false);
        },
    },
    async mounted() {
        await this.updateData();
        await this.loadFieldsAdvance();
    },
};
</script>
